import React, { useContext } from "react";

// context
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";

// assets
import icon_add_community from "bodycodi/cmap/app/svg/icon_add_community.svg";

const AddCommunityButton = () => {
  const { dispatch } = useContext(DispatchContext);

  const handleAddCommunity = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "ADD_COMUNITY_POP",
      open: { addComunityPop: true, addComunitySeqmember: "" },
    });
  };

  return (
    <div className="add-comunity-btn" onClick={handleAddCommunity}>
      <img src={icon_add_community} />
    </div>
  );
};

export default AddCommunityButton;
